import {Store} from 'svelte/store.js';

export function range(n,n2) {
  const rng = [];
  if (n2) {
    for (let i = n; i < n2; i++) {
      rng.push(i);
    }
  } else {
    for (let i = 0; i < n; i++) {
      rng.push(i);
    }
  }
  return rng;
}

export function mse(x1, x2) {
  let res = 0;
  for (let i = 0; i < x1.length; i++) {
    res += Math.pow(x1[i] - x2[i], 2);
  }
  return res;
}

export function pctAgreement(x1, x2, tolerance) {
  let tol = tolerance || 0.01;
  let same = 0;
  for (let i = 0; i < x1.length; i++)
    same += Math.abs(x1[i] - x2[i]) < tol;
  return same / x1.length;
}

export function bwIoU(x1, x2) {
  let numer = 0;
  let denom = 0;
  for (let i = 0; i < x1.length; i++) {
    const a = Math.round(x1[i]);
    const b = Math.round(x2[i]);
    numer += a && b;
    denom += a || b;
  }
  if (denom) {
    return numer / denom;
  } else {
    return 1;
  }
}

export function IoU(x1, x2) {
  let union = 0;
  let intersection = 0;
  for (let i = 0; i < x1.length; i++) {
    union += Math.max(x1[i], x2[i]);
    intersection += Math.min(x1[i], x2[i]);
  }
  return intersection / union;
}

export function scaledMAE(x1, x2) {
  let num = 0;
  let den = 0.01;
  for (let i = 0; i < x1.length; i++) {
    den += Math.abs(x1[i]);
    den += Math.abs(x2[i]);
    num += Math.abs(x1[i] - x2[i]);
  }
  return num / den;
}

export function randomId() {
  return `${new Date().getTime()}_${Math.random().toString().slice(2)}`;
}

export function randomNormal(K) {
  return Array.from(tf.tidy(() => {
    return tf.randomNormal([K]).dataSync();
  }));
}

export function copyArray(a) {
  return JSON.parse(JSON.stringify(a));
}

export function arrayToggle(a, el) {
  if (a.indexOf(el) >= 0) {
    return a.filter((val) => val != el);
  } else {
    return a.concat([el]);
  }
}

export function sampleOne(array) {
  return array[Math.floor(Math.random()*array.length)];
}

export function getQuery(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}

export function sampleMany(arr, size) {
  if (size > arr.length) {
    console.log(`WARNING: trying to sample ${size} elements from array of length ${arr.length}`);
    return arr;
  }
  var shuffled = arr.slice(0), i = arr.length, min = i - size, temp, index;
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
}

export function reject(val, arr) {
  return arr.filter((el) => val != el);
}

export function shuffle(arr) {
  var shuffled = arr.slice(0), i = arr.length, temp, index;
  while (i--) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled;
}

export function within(v1, v2, v) {
  const lo = Math.min(v1, v2);
  const hi = Math.max(v1, v2);
  return (v >= lo) && (v <= hi);
};

export function keyEvent(code) {
  return function (node, callback) {
    node.addEventListener('keydown', handleKeydown);

    function handleKeydown(event) {
      if (event.keyCode === code) {
        callback.call(this, event);
      }
    }

    return {
      destroy() {
        node.removeEventListener('keydown', handleKeydown);
      }
    };
  }
}

export const enter = keyEvent(13);

export function maskZ(input, $discDims, $c_masks) {
  const masks = [];
  $discDims.forEach((dim, i) => {
    for (let j = 0; j < dim.options.length; j++)
      if (input[dim.index + j] == 1)
        masks.push($c_masks[i][j]);
  });
  const san = copyArray(input);
  for (const mask of masks)
    for (const [i, m] of mask.entries())
      san[i] = san[i] * m;
  return san;
}

export function symmetricDifference(setA, setB) {
    var _difference = new Set(setA);
    for (var elem of setB) {
        if (_difference.has(elem)) {
            _difference.delete(elem);
        } else {
            _difference.add(elem);
        }
    }
    return _difference;
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function associateFlatAndNested(hierarchy, data, i, j, prefix) {
  for (let k = 0; k < hierarchy.length; k++) {
    const dimension = hierarchy[k];
    if (dimension.type == 'continuous') {
      dimension.flat = data.contDims[i];
      dimension.flatIdx = i;
      data.flatDims.push(dimension.flat);
      i += 1;
    } else {
      dimension.flat = data.discDims[j];
      dimension.flatIdx = j;
      data.flatDims.push(dimension.flat);
      j += 1;
      const iInit = i;
      const jInit = j;
      dimension.options.forEach((opt,l) => {
        const res = associateFlatAndNested(opt, data, i, j, prefix+`${k+1}.${l+1}`);
        opt.childContIndexes = range(i, res.i);
        opt.childDiscIndexes = range(j, res.j);
        dimension.flat.options[l].childContIndexes = range(i, res.i);
        dimension.flat.options[l].childDiscIndexes = range(j, res.j);
        i = res.i;
        j = res.j;
      });
      dimension.childContIndexes = range(iInit,i);
      dimension.childDiscIndexes = range(jInit,j);
      dimension.flat.childContIndexes = range(iInit,i);
      dimension.flat.childDiscIndexes = range(jInit,j);
    }
    if (hierarchy.length < 2) {
      dimension.flat.name = `Dial ${prefix}`;
    } else {
      dimension.flat.name = `Dial ${prefix}${k+1}`;
    }
  }
  return { i, j };
}

export function setupDimensionMetadata(data) {
  if (data.z && data.z.length) {
    if (typeof data.Dx == 'undefined') {
      if (data.dataKey == 'timeseries')
        data.Dx = 64;
      else if (data.dataKey == 'dsprites')
        data.Dx = 64*64;
    }
    if (typeof data.Dz == 'undefined') {
      data.Dz = data.z[0].length;
    }
    if (typeof data.Dc == 'undefined') {
      data.Dc = data.c.map((c,i) => {
        return c[0].length;
      });
    }
  } else {
    data.numExamples = [];
    data.x_orig = [];
    data.c = [];
    data.z = [];
  }
  data.Dcz = data.Dz;
  data.Dc.forEach(d => data.Dcz += d);

  data.defaultInput = [];
  for (let K of data.Dc) {
    const onehot = range(K).map((k) => 0);
    onehot[0] = 1
    data.defaultInput = data.defaultInput.concat(onehot);
  }
  data.defaultInput = data.defaultInput.concat(range(data.Dz).map((el) => 0));

  const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  let k = 0;
  data.discDims = data.Dc.map((numOpts,i) => {
    const res = {
      id: `disc-dim-${i}`,
      name: `Button #${i+1}`,
      type: 'discrete',
      discIndex: i,
      index: k,
      options: range(numOpts).map((j) => {
        return {
          id: `disc-dim-${i}-val-${j}`,
          name: `Value ${alpha[j]}`,
          optIndex: j,
          index: k+j
        };
      })
    };
    k += numOpts;
    return res;
  });

  data.contDims = range(data.Dz).map((i) => {
    return {
      id: `cont-dim-${i}`,
      name: `Dial #${i+1}`,
      type: 'continuous',
      contIndex: i,
      index: k+i,
    }
  });

  data.flatDims = [];

  associateFlatAndNested(data.hierarchy, data, 0, 0, '');

  data.c_masks = data.discDims.map((dim) => {
    return dim.options.map((opt) => {
      const m = range(data.Dcz).map((_) => 1);

      for (let i of dim.childContIndexes) m[data.contDims[i].index] = 0;
      for (let j of dim.childDiscIndexes)
        for (let opt2 of data.discDims[j].options)
          m[opt2.index] = 0;

      for (let i of opt.childContIndexes) m[data.contDims[i].index] = 1;
      for (let j of opt.childDiscIndexes)
        for (let opt2 of data.discDims[j].options)
          m[opt2.index] = 1;

      return m;
    });
  });

  if (!data.z_lims && data.z_percs) {
    data.z_lims = [];
    for (let i = 0; i < data.z_percs.length; i++) {
      const lo = data.z_percs[i][1];
      const hi = data.z_percs[i][99];
      data.z_lims.push([lo, hi]);
    }
  }
  window.data_ = data;
}

export function getTurkInfo() {
  const turk = {};
  const param = function(url, name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return (results == null) ? "" : results[1];
  };

  const src = param(window.location.href, "assignmentId") ? window.location.href : document.referrer;
  const keys = ["assignmentId", "hitId", "workerId", "turkSubmitTo"];
  keys.map((key) => {
    turk[key] = unescape(param(src, key));
  });

  turk.previewMode = (turk.assignmentId == "ASSIGNMENT_ID_NOT_AVAILABLE");
  turk.outsideTurk = (!turk.previewMode && turk.hitId === "" && turk.assignmentId == "" && turk.workerId == "")
  return turk;
};

export function submitToTurk(extraData) {
  const turkInfo = getTurkInfo();
  const assignmentId = turkInfo.assignmentId;
  const turkSubmitTo = turkInfo.turkSubmitTo;
  if (!assignmentId || !turkSubmitTo) return;
  const dataString = [];
  const data = extraData || {};
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      dataString.push(key + "=" + escape(data[key]));
    }
  }
  dataString.push("assignmentId=" + assignmentId);
  const url = turkSubmitTo + "/mturk/externalSubmit?" + dataString.join("&");
  window.location.href = url;
};

export const timeseriesX = [
  -3.2, -3.1, -3. , -2.9, -2.8, -2.7, -2.6, -2.5, -2.4, -2.3, -2.2,
  -2.1, -2.0, -1.9, -1.8, -1.7, -1.6, -1.5, -1.4, -1.3, -1.2, -1.1,
  -1.0, -0.9, -0.8, -0.7, -0.6, -0.5, -0.4, -0.3, -0.2, -0.1,  0.0,
   0.1,  0.2,  0.3,  0.4,  0.5,  0.6,  0.7,  0.8,  0.9,  1. ,  1.1,
   1.2,  1.3,  1.4,  1.5,  1.6,  1.7,  1.8,  1.9,  2.0,  2.1,  2.2,
   2.3,  2.4,  2.5,  2.6,  2.7,  2.8,  2.9,  3.0,  3.1
];

export const timeseriesLimits = [
  [-1, 1],
  [-4, 4],
  [0, 10],
  [0, 10],
  [0, Math.round(2*Math.PI*100)/100]
];

export const timeseriesPcts = {
  0: [-0.999893135913239, -4.0281563225185515, 8.961289244786438e-06, 5.30015059428693e-05, 0.00016322766089180458],
  1: [-0.980001754475396, -2.311269540748075, 0.009841987035866726, 0.010443744378365831, 0.06186736006541578],
  2: [-0.9591688695071544, -2.0597147184340754, 0.020172961922099046, 0.019924062418860723, 0.12638822768553348],
  5: [-0.8994738404725823, -1.6427975809696242, 0.05129308348820467, 0.05070599647225438, 0.32238116731493033],
  25: [-0.4941112717424068, -0.6686323453876338, 0.2866509430647027, 0.2883639438105464, 1.5761996757550798],
  33: [-0.33375182815617055, -0.4373575008559303, 0.39893723386147084, 0.40118439436802233, 2.0825400887507897],
  45: [-0.09156294724735049, -0.12307848967091312, 0.5954192268013553, 0.5949511401031627, 2.836016251220051],
  48: [-0.03376775734792464, -0.046741919847168065, 0.6515293335680905, 0.65199031145571, 3.025931706046867],
  50: [0.006909467659452551, 0.0030745765028161558, 0.6893712424079417, 0.692993909968308, 3.1471703713066974],
  52: [0.04549216284549388, 0.055686621517758286, 0.7297143912257275, 0.7353312031774573, 3.268321217071762],
  55: [0.10550435593921875, 0.134326116379127, 0.7939679561188211, 0.8010356603962991, 3.4562392792396857],
  67: [0.34094280794872633, 0.45290684225955835, 1.1047393275041903, 1.1099313405200761, 4.20633149527023],
  75: [0.4998243442458409, 0.6855147522702414, 1.3778194991448511, 1.3861515588947089, 4.696628401872491],
  95: [0.8976675506469572, 1.657334488497137, 2.9811892605869037, 2.976451862795523, 5.954853628563546],
  98: [0.9588376947631542, 2.0786385449381495, 3.867735015756658, 3.928039182143862, 6.146009016541035],
  99: [0.9787371305578826, 2.3586180822663976, 4.499254127504022, 4.545999088089283, 6.2125160421037435],
  100: [0.9999663855650138, 3.909037947948695, 12.033450628308787, 11.29280329076291, 6.282994642616362]
};

export function timeseriesExample(z) {
  return timeseriesX.map((x) => {
    return x*z[0] + z[1] + z[2] * Math.sin(x*z[3] + z[4]);
  });
}

export function Unif(a,b) {
  return a + (b-a)*Uniform();
}

export function Uniform() {
  return tf.randomUniform([1]).dataSync()[0];
}
export function Normal() {
  return tf.randomNormal([1]).dataSync()[0];
}
export function Exponential() {
  return -Math.log(Uniform());
}

export function sampleTimeseries() {
  return tf.tidy(() => {
    const m = 2 * (Uniform() - 0.5);
    const b = Normal();
    const A = Exponential();
    const w = Exponential();
    const ph = 2 * Math.PI * Uniform();
    return [m,b,A,w,ph].map((el,i) => {
      const rounded = Math.round(el*100)/100;
      const clamped = Math.min(
        Math.max(
          rounded,
          timeseriesLimits[i][0]
        ),
        timeseriesLimits[i][1]
      );
      return clamped;
    });
  });
};

export function timeseriesRotate(z) {
  const c = Math.cos(Math.PI / 12.0);
  const s = Math.sin(Math.PI / 12.0);

  const rescale = (i, v) => {
    const lims = timeseriesLimits[i];
    const lo = lims[0];
    const hi = lims[1];
    const loc = (hi+lo)/2.0;
    const scale = (hi-lo)/2.0;
    return v * scale + loc;
  };
  /* cos sin
   * -sin cos */
  const z2 = [
    rescale(0, z[0]*c + z[1]*s),
    rescale(1, z[1]*c - z[0]*s),
    rescale(2, z[2]*c + z[3]*s),
    rescale(3, z[3]*c - z[2]*s),
    rescale(4, z[4])
  ];
  return z2;
}

export function timeseriesRotateInvert(z2) {
  const c = Math.cos(Math.PI / 12.0);
  const s = Math.sin(Math.PI / 12.0);

  const z_ = z2.map((el,i) => {
    const lims = timeseriesLimits[i];
    const lo = lims[0];
    const hi = lims[1];
    const loc = (hi+lo)/2.0;
    const scale = (hi-lo)/2.0;
    return (el - loc) / scale;
  });

  /* cos -sin
   * sin cos */
  const z = [
    z_[0]*c - z_[1]*s,
    z_[1]*c + z_[0]*s,
    z_[2]*c - z_[3]*s,
    z_[3]*c + z_[2]*s,
    z_[4]
  ];

  return z;
}

export function rotatedTimeseriesExample(z) {
  return timeseriesExample(timeseriesRotate(z));
}

export function toy2DExample(z) {
  const res = [];
  const color = 1 - z[1];
  for (let i = 0; i < 64; i++) {
    for (let j = 0; j < 64; j++) {
      const inside = (Math.sqrt(Math.pow(i-31, 2) + Math.pow(j-31, 2)) < 24 * z[0] + 4);
      res.push(inside * color + (1-inside) * (1-color));
    }
  }
  return res
}

export function toy3DExample(z2) {
  const res = [];

  const color = 1 - 0.25 * z2[0] - 0.5 * z2[1];

  for (let i = 0; i < 64; i++) {
    for (let j = 0; j < 64; j++) {
      const radius1 = 24 * (0.75 * z2[0] + 0.5 * z2[2]) + 4;
      const radius2 = radius1 * 0.75 * (0.5 * z2[1] + 0.5 * z2[2]); 
      const dist = Math.sqrt(Math.pow(i-31, 2) + Math.pow(j-31, 2));
      const inside1 = dist < radius1;
      const inside2 = dist < radius2;
      if (inside2) {
        res.push(color);
      } else if (inside1) {
        res.push((color + (1-color)) / 2);
      } else {
        res.push(1-color);
      }
    }
  }

  return res;
}

export class Model extends Store {
  constructor(data) {
    setupDimensionMetadata(data);
    const { Dc, Dz, discDims, contDims, z_lims, c_masks } = data;

    data.maskZ = (cmz) => {
      const masks = [];
      discDims.forEach((dim, i) => {
        for (let j = 0; j < dim.options.length; j++)
          if (cmz[dim.index + j] == 1)
            masks.push(c_masks[i][j]);
      });
      const san = copyArray(cmz);
      for (const mask of masks)
        for (const [i, m] of mask.entries())
          san[i] = san[i] * m;
      return san;
    }

    if (data.z && data.z.length) {
      window.samp_order = shuffle(range(data.z.length));
      window.samp_idx = 0;
    }

    data.sampleLatentComponents = () => {
      if (data.z && data.z.length && data.dataKey != 'chopsticks' && data.dataKey != 'spaceshapes') {
        // If given, sample from a deterministic list of latent values
        const i = window.samp_order[window.samp_idx % data.z.length];
        window.samp_idx = window.samp_idx + 1;
        const cs = [];
        const z = [];
        for (let val of data.z[i]) {
          z.push(Math.round(100 * val) / 100); // IMPORTANT: round for sliders
        }
        for (let j of range(Dc.length)) {
          cs.push(copyArray(data.c[j][i]));
        }
        return { cs, z };
      } else if (data.dataKey == 'timeseries' && data.modelKey == 'supervised') {
        const z = sampleTimeseries();
        const cs = [];
        return { cs, z };
      } else if (data.dataKey == 'timeseries' && data.modelKey == 'supervised_rotated') {
        const z = timeseriesRotateInvert(sampleTimeseries());
        const cs = [];
        return { cs, z };
      } else {
        // Otherwise, generate latent values from discrete or continuous uniforms
        console.log("GENERATING DATA FROM UNIFORMS");
        const cs = [];
        const z = [];
        for (let dc of Dc) {
          const c = range(dc).map((_) => 0);
          c[sampleOne(range(dc))] = 1;
          cs.push(c);
        }
        for (let i of range(Dz)) {
          const lo = z_lims[i][0];
          const hi = z_lims[i][1];
          const val = lo + (hi-lo) * Math.random();
          z.push(Math.round(100 * val) / 100);
        }
        return { cs, z };
      }
    }

    data.mergeCMZ = (cs, z) => {
      let res = [];
      for (let c of cs)
        res = res.concat(c);
      res = res.concat(z);
      return data.maskZ(res);
    }

    data.sampleCMZ = () => {
      const { cs, z } = data.sampleLatentComponents();
      return data.mergeCMZ(cs, z);
    }

    if (typeof data.decoder.predict == 'undefined') {
      data.decode = data.decoder;
      data.decodes = (cmzs) => cmzs.map(data.decoder);
    } else {
      data.decode = (cmz) => {
        return tf.tidy(() => {
          const tensor = tf.tensor2d([data.maskZ(cmz)]);
          return data.decoder.predict(tensor).dataSync();
        });
      }

      data.decodes = (cmzs) => {
        if (!cmzs.length) return [];
        const output = tf.tidy(() => {
          const tensor = tf.tensor2d(cmzs.map(data.maskZ));
          return data.decoder.predict(tensor).dataSync();
        });
        return range(cmzs.length).map((k) => {
          return output.slice(k*data.Dx, (k+1)*data.Dx);
        });
      }
    }

    const defaultCs = [];
    const defaultZ = [];
    for (let dc of Dc) {
      const c = range(dc).map((_) => 0);
      c[0] = 1;
      defaultCs.push(c);
    }
    for (let i of range(Dz)) {
      const lo = z_lims[i][0];
      const hi = z_lims[i][1];
      const val = (lo + hi) / 2.0
      defaultZ.push(Math.round(100 * val) / 100);
    }
    data.defaultInput = data.mergeCMZ(defaultCs, defaultZ);

    data.getLoMedHi = (dim, sampleType) => {
      const st = sampleType || getQuery('sample-type') || 'pct-unifs';
      let lo;
      let hi;
      let mid;
      const i = dim.contIndex;
      if (st == '1-50-99') {
        lo = data.z_pcts[1][i];
        hi = data.z_pcts[99][i];
        mid = data.z_pcts[50][i];
      } else if (st == 'min-max-avg') {
        lo = data.z_lims[i][0];
        hi = data.z_lims[i][1];
        mid = 0.5*(lo+hi);
      } else if (st == 'pct-unifs') {
        lo = Unif(data.z_pcts[1][i], data.z_pcts[5][i]);
        hi = Unif(data.z_pcts[95][i], data.z_pcts[99][i]);
        mid = Unif(data.z_pcts[48][i], data.z_pcts[52][i]);
      } else {
        console.log("No lo/med/hi sampling strategy specified!");
        lo = data.z_pcts[1][i];
        hi = data.z_pcts[99][i];
        mid = data.z_pcts[50][i];
      }
      return [lo, mid, hi];
    }

    super(data);
  }
}

export function getWorkerId() {
  let workerId = getTurkInfo().workerId;
  if (!workerId) {
    if (getCookie('dtakquizworker')) {
      workerId = getCookie('dtakquizworker');
    } else {
      workerId = window.userId;
    }
  } else {
    setCookie('dtakquizworker', workerId, 365);
  }
  return workerId;
}

export async function checkPermitted() {
  let checkUrl;
  if (location.hostname == 'localhost')
    checkUrl = 'http://localhost:3000/completions';
  else
    checkUrl = 'https://dtak-mturk-survey-data.herokuapp.com/completions';

  const workerId = getWorkerId();
  const scope = 'latent-rep-interpretability-quiz';

  checkUrl = `${checkUrl}?worker_id=${workerId}&scope=${scope}`;

  const response = await fetch(checkUrl);
  const json = await response.json();

  if (json && json.status == 'first_time') {
    return true;
  } else if (json && json.status == 'completed') {
    return false;
  } else {
    return undefined;
  }
}

export function logEvent(event, context) {
  let logUrl;
  if (location.hostname == 'localhost')
    logUrl = 'http://localhost:3000/logs';
  else
    logUrl = 'https://dtak-mturk-survey-data.herokuapp.com/logs';

  const body = {
    scope: 'latent-rep-interpretability-quiz',
    key: event.name,
    value: {
      userId: window.userId,
      workerId: getWorkerId(),
      session: window.session,
      timestamp: new Date().getTime(),
      eventData: event.data,
      eventContext: context,
      turkInfo: getTurkInfo()
    }
  };
  
  if (location.hostname == 'localhost')
    console.log(body);

  fetch(logUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
}
